"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// TODO Might want to perf test this - This is using immutable data
var addCluster = exports.addCluster = function addCluster(distanceMatrix, clusters, newCluster, distanceFn) {
    return clusters.reduce(function (updatedDistanceMatrix, existingCluster) {
        // if this is this cluster don't create an entry for it
        if (existingCluster.id === newCluster.id) {
            return updatedDistanceMatrix;
        }

        // TODO PERF Potentially only add once per cluster
        var distance = distanceFn(newCluster, existingCluster);
        updatedDistanceMatrix.matrix[newCluster.id] = updatedDistanceMatrix.matrix[newCluster.id] || {};
        updatedDistanceMatrix.matrix[newCluster.id][existingCluster.id] = distance;

        updatedDistanceMatrix.distances = [].concat(_toConsumableArray(updatedDistanceMatrix.distances), [{ dist: distance, clusters: [newCluster.id, existingCluster.id] }]);

        updatedDistanceMatrix.sorted = false;

        return updatedDistanceMatrix;
    }, _extends({}, distanceMatrix)) // Map of ID : ID : dist
    ;
};

var getDistance = exports.getDistance = function getDistance(distanceMatrix, cluster1Id, cluster2Id) {
    if (!isNaN(distanceMatrix.matrix[cluster1Id][cluster2Id])) {
        return distanceMatrix.matrix[cluster1Id][cluster2Id];
    } else if (!isNaN(distanceMatrix.matrix[cluster2Id][cluster1Id])) {
        return distanceMatrix.matrix[cluster2Id][cluster1Id];
    }
    return Infinity;
};

var createDistanceMatrix = exports.createDistanceMatrix = function createDistanceMatrix(clusters, distanceFn) {
    return (
        // Create a map to every distance from every cluster
        clusters.reduce(function (allDistanceMap, cluster) {
            return addCluster(allDistanceMap, clusters, cluster, distanceFn);
        }, { distances: [], matrix: {}, sorted: false })
    );
};

var removeClusters = exports.removeClusters = function removeClusters(distanceMatrix, cluster1Id, cluster2Id) {
    // Remove any distances which match the cluster IDs
    var distances = distanceMatrix.distances.filter(function (distEntry) {
        return distEntry.clusters.indexOf(cluster1Id) === -1 && distEntry.clusters.indexOf(cluster2Id) === -1;
    });

    // Remove the entries in the matrix for both clusters
    // const matrix = omit(distanceMatrix.matrix, [cluster1Id, cluster2Id]);

    return _extends({}, distanceMatrix, {
        distances: distances
    });
};

var sortByMinDist = exports.sortByMinDist = function sortByMinDist(distEntryA, distEntryB) {
    return distEntryA.dist - distEntryB.dist;
};

var getMinDistance = exports.getMinDistance = function getMinDistance(distanceMatrix) {
    var distances = distanceMatrix.distances;
    if (!distanceMatrix.sorted) {
        distances = distances.sort(sortByMinDist);
    }
    return distances[0];
};


//////////////////
// WEBPACK FOOTER
// ./src/common/documentOrder/structures/distanceMatrix.js
// module id = 2262
// module chunks = 0